import Api from '@/api'
import Store from '@/store'

import Storage from '@/helpers/storage'

import Firebase from '@/modules/firebase'
import I18n from '@/modules/i18n'
import Loop from '@/modules/loop'
import Tag from '@/modules/tag'
import Tracking from '@/modules/tracking'
import UserAgent from '@/modules/userAgent'

const auth = {

    Statuses: {
        SUCCESS: 1,
        UNKNOWN_ERROR: 0,
        INVALID_CREDENTIALS: 2,
        TIMEOUT: 3,
        APPLICATION_PASSWORD: 4,
        IMAP_DISABLED: 5
    },

    errorToStatus: function (error) {
        switch (error) {
            case 'invalid_credentials':
                return this.Statuses.INVALID_CREDENTIALS
            case 'timeout':
                return this.Statuses.TIMEOUT
            case 'application_password':
                return this.Statuses.APPLICATION_PASSWORD
            case 'imap_disabled':
                return this.Statuses.IMAP_DISABLED
            default:
                return this.Statuses.UNKNOWN_ERROR
        }
    },

    checkAuth: function (to, from, next) {

        if (Storage.getItem('token')) {

            Store.dispatch('getUserAsync')
                .then(user => {

                    if (to.path === '/user-form') {

                        next()

                    } else if (user && (!user.firstname || !user.lastname || (!user.birthYear || user.birthYear < 1))) {

                        next({path: '/user-form'})

                    } else if (Storage.getItem('fetchStatus') !== 'done' && to.path !== '/settings' && to.path !== '/fetch' && to.path !== '/add-inbox') {

                        next({path: '/fetch'})

                    } else {

                        next()

                    }

                })
                .catch(() => {
                    auth.disconnect()
                })

        } else {

            auth.disconnect()

        }

    },

    checkNotAuth: function (to, from, next) {

        Storage.getItem('token') ? next({path: '/newsletters'}) : next()

    },

    redirect: function (to, from, next) {

        Storage.getItem('token') ? next({path: '/newsletters'}) : auth.disconnect()

    },

    connect: async function (Vue, email, password, provider) {

        Tag.infoAll(Vue, 'status_connection_started', provider)

        const device = UserAgent.getDevice()
        const language = I18n.get(Vue)
        const millisecondsToWait = await Firebase.getValue('login_timeout_seconds', 'Number') * 1000 || 60 * 1000
        const deadLineTime = new Date().getTime() + millisecondsToWait
        const millisecondsToDelay = await Firebase.getValue('login_delay_retry_seconds', 'Number') * 1000 || 30 * 1000

        return new Promise((resolve, reject) => connectRec(Vue, {email, password, language, device, provider}, {deadLineTime, millisecondsToDelay}, resolve, reject))
    },

    disconnect: function (requestToServer = true) {
        if (requestToServer) {
            Api.auth.disconnect()
        }
        if (Store) { // fixme: Iphone crash
            Store.dispatch('disconnect')
        }
        Storage.clear()
        location.href = '/'

    },

    sendMagicLinkEmail: function (email) {

        const lang = localStorage.getItem('lang') || 'en'

        return Api.auth.sendMagicLinkEmail(email, lang)

    },

    getMagicLinkUser: function (code) {

        return Api.auth.getMagicLinkUser(code)

    },

    getAuthLink: function (code) {

        return Api.auth.authLongCheck(code)

    },

    deleteEmailAccount: function (email) {

        return Api.auth.deleteEmailAccount(email)
            .then(data => {
                Storage.setItem('aToken', data.token)
                return Loop.start(() => Api.auth.deleteEmailAccountCheck(email))
            })

    },

    microsoftAuth: async function (Vue, aToken) {

        return await postConnection(Vue, aToken)

    },

    microsoftApi: function (Vue, email) {

        Tag.pageViewAmplitude(Vue, 'microsoft')

        const token = Storage.getItem('token') || ''
        const emailStr = encodeURIComponent(email) || ''
        const utmSource = Storage.getItem('utm_source') || ''
        const utmMedium = Storage.getItem('utm_medium') || ''
        const utmCampaign = Storage.getItem('utm_campaign') || ''
        const referrer = Storage.getItem('referrer') || ''
        const device = UserAgent.getDevice()
        const language = I18n.get(Vue)

        window.location.href = `/login/microsoft?token=${token || ''}&email=${emailStr}&utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}&referrer=${referrer}&device=${device}&language=${language}`

    },

    validConsent: function (lang, email) {

        const utms = Tracking.getTracking()

        const body = {
            email,
            language: lang,
            device: UserAgent.getDevice()
        }

        return Api.auth.validConsent(body, utms)

    }

}

function connectRec(Vue, {email, password, language, device, provider}, {deadLineTime, millisecondsToDelay}, resolve, reject) {
    Api.auth.connect(email, password, device, language)
        .then(async data => {
            resolve(await postConnection(Vue, data.token))
        })
        .catch(error => {
            if (error) {
                const errorStatus = auth.errorToStatus(error.message)

                Tag.infoGa(Vue, 'status_connection_fail', provider, errorStatus)

                if (((Date.now() + millisecondsToDelay) < deadLineTime) && (error.message === 'timeout' || error.message === 'unknown_error')) {
                    setTimeout(() => {
                        connectRec(Vue, {email, password, language, device, provider}, {deadLineTime, millisecondsToDelay}, resolve, reject)
                    }, millisecondsToDelay)

                } else {
                    reject(error)
                }
            } else {
                reject(new Error('unknown_error'))
            }
        })
}

export default auth

function postConnection(Vue, aToken) {

    Storage.setItem('aToken', aToken)

    return Loop.start(Api.auth.authCheck)
        .then(result => {

            Storage.setItem('token', result.token)
            Store.dispatch('setUser', result.user)

            const provider = result.user.accounts[0].provider

            if (result.new) {
                Tag.accountCreated(provider)
                Tag.accountCreatedAmplitude(Vue, provider)
            }

            if (result.association) {
                Tag.accountAssociated()
                Tag.accountAssociatedAmplitude(Vue)
            }

        })

}
